import { ConversationType } from '../core/hub-types';

export type ConversationTransition = 'forward' | 'back' | 'fade' | 'none';

/**
 * How deep a place in the chat window is: the conversation list, then groups and doctors, then a patient's own
 * conversations (their chat, a referral about them, the patient app). Going deeper slides forward (the new page comes
 * in from the right), going up slides back, and a move at the same depth crossfades.
 */
function depth(place: ConversationType | 'list'): number {
  if (place === 'list') return 0;
  return place === 'patient' || place === 'referral' || place === 'patient_direct' ? 2 : 1;
}

export function conversationTransition(from: ConversationType | 'list', to: ConversationType | 'list'): ConversationTransition {
  if (from === 'list' && to === 'list') return 'none';
  const d = depth(to) - depth(from);
  return d > 0 ? 'forward' : d < 0 ? 'back' : 'fade';
}
